// Global open/close state for the guest login modal. The modal itself is
// rendered once in LayoutHeader; other components (e.g. GuestLoginPrompt on
// /guest when logged out) can open it without owning the modal.
// `initialMode` is read when GuestLoginForm mounts (the form remounts on each
// open via formKey). Deep links pass `register` so the banner can land on the
// sign-up tab; header/prompt stay on `login`.

export type GuestLoginModalMode = 'login' | 'register'
export type GuestLoginModalSource = 'ui' | 'deep_link'

export default function useGuestLoginModal () {
  const isOpen = useState('guest-login-modal-open', () => false)
  const initialMode = useState<GuestLoginModalMode>('guest-login-modal-mode', () => 'login')
  const openSource = useState<GuestLoginModalSource>('guest-login-modal-source', () => 'ui')

  const open = (
    mode: GuestLoginModalMode = 'login',
    source: GuestLoginModalSource = 'ui'
  ) => {
    // `@click="open"` would pass the MouseEvent as `mode` and the form
    // would mount in neither login nor register — email + "Anmelden" +
    // "Zurück zur Anmeldung" only. Ignore anything that is not a tab.
    initialMode.value = mode === 'register' ? 'register' : 'login'
    openSource.value = source === 'deep_link' ? 'deep_link' : 'ui'
    isOpen.value = true
  }

  const close = () => {
    isOpen.value = false
  }

  return { isOpen, initialMode, openSource, open, close }
}
